import styled from 'styled-components'

import GrayHalfHexagon from '@public/images/gray-hexagon.svg'
import OrangeHalfHexagon from '@public/images/orangeHalfHexagon.svg'

export const OrangeHalfHexagonLeft = styled(GrayHalfHexagon)`
  left: -250px;
  position: absolute;
  top: 1460px;
`

export const OrangeHalfHexagonRight = styled(OrangeHalfHexagon)`
  position: absolute;
  right: -25px;
  top: 100px;
  transform: rotate(180deg);
`
